const VERIFIED_TTL_MS = 60 * 60 * 1000

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return

  const { stagingMode, apiBase } = useRuntimeConfig().public
  if (!stagingMode) return

  if (to.path === '/staging-login') return

  const redirectUrl = `/staging-login?redirect=${encodeURIComponent(to.fullPath)}`

  const savedPassword = localStorage.getItem('staging-password')
  if (!savedPassword) {
    return navigateTo(redirectUrl)
  }

  const verifiedAt = Number(localStorage.getItem('staging-verified-at'))
  if (verifiedAt && Date.now() - verifiedAt < VERIFIED_TTL_MS) {
    return
  }

  try {
    const res = await fetch(`${apiBase}/staging-verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password: savedPassword }),
    })

    if (!res.ok) {
      return navigateTo(redirectUrl)
    }

    const data: { valid: boolean } = await res.json()

    if (data.valid) {
      localStorage.setItem('staging-verified-at', String(Date.now()))
      return
    }
  } catch {
    // Fail closed — block access when API is unreachable
    return navigateTo(redirectUrl)
  }

  localStorage.removeItem('staging-password')
  localStorage.removeItem('staging-verified-at')
  return navigateTo(redirectUrl)
})
